module.exports = __webpack_public_path__ + "img/Kr-plugin1.e0422e63.png";